import {
  tableState,
  tableMutations,
  tableActions,
  tableGetters
} from "@tt/vue-components";
import InventoryService from "@/services/InventoryService";
import groupFilter from "@/store/modules/reservationItems/filters/groupFilter";
import statusFilter from "@/store/modules/reservationItems/filters/statusFilter";
import skuFilter from "@/store/modules/reservationItems/filters/skuFilter";
import idFilter from "@/store/modules/reservationItems/filters/idFilter";
import emailFilter from "@/store/modules/reservationItems/filters/emailFilter";
import locationFilter from "@/store/modules/reservationItems/filters/locationFilter";

const reservationOverview = {
  requestController: null,
  namespaced: true,
  state: {
    ...tableState,
    reservation: null
  },
  modules: {
    idFilter,
    skuFilter,
    groupFilter,
    statusFilter,
    emailFilter,
    locationFilter
  },
  mutations: {
    ...tableMutations,
    SET_RESERVATION(state, reservation) {
      state.reservation = reservation;
    }
  },
  actions: {
    ...tableActions,
    fetchItems({ state, commit }) {
      commit("SET_LOADING", true);

      const params = {
        pagination: state.pagination,
        sorting: state.sorting,
        search: state.search
      };

      if (this.requestController) {
        this.requestController.abort();
      }
      this.requestController = new AbortController();

      InventoryService.reservationItems.list(params, { signal: this.requestController.signal })
        .then(json => {
          if (json) {
            commit("SET_ITEMS", json);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    selectReservation({commit}, item) {
      if (item !== null) {
        commit("SET_RESERVATION", item);
        commit("SET_ITEM", item);
      } else {
        commit("SET_RESERVATION", null);
        commit("SET_ITEM", null);
      }
    },
    patch({ commit }, resource) {
      return new Promise((resolve, reject) => {
        InventoryService.reservationItems.patch(resource.id, resource.body)
          .then((result) => {
            commit("EDIT_ITEM", result)
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject(err["hydra:description"]);
          });
      });
    },
  },
  getters: {
    ...tableGetters
  }
};

export default reservationOverview;
